import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20product%20flat%20lay%20on%20natural%20light%20wood%20surface%2C%20diverse%20fashion%20items%20including%20leather%20shoes%20silk%20scarf%20watch%20and%20sunglasses%20arranged%20in%20organic%20flowing%20composition%2C%20soft%20golden%20hour%20sunlight%20casting%20gentle%20shadows%2C%20editorial%20photography%20style%2C%20rich%20warm%20earth%20tones%20with%20touches%20of%20olive%20green%20and%20terracotta%2C%20no%20text%20no%20logos%20no%20watermarks%2C%20sophisticated%20European%20aesthetic%2C%20natural%20textures%20visible&width=1800&height=1200&seq=hero-itaobuy-v2&orientation=landscape&nocache=true"
          alt="Itaobuy Spreadsheet prodotti"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/12 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 text-center lg:text-left pt-20 lg:pt-0">
            <p className="text-sm md:text-base text-white/80 font-light tracking-wider mb-4 uppercase">
              Itaobuy Spreadsheet Italia
            </p>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-6">
              La guida italiana completa per{' '}
              <span className="italic">Itaobuy</span>{' '}
              <span className="italic">Spreadsheet</span>
            </h1>
            <p className="text-base md:text-lg text-white/80 font-light leading-relaxed mb-8 max-w-xl">
              Scopri tutto quello che devi sapere su Itaobuy Spreadsheet:
              funzionalità, sicurezza, recensioni, tutorial e confronti aggiornati
              per il 2026.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-white text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                Itaobuy Sheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-white/60 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                Buy It Now
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 mt-8 justify-center lg:justify-start">
              <span className="flex items-center gap-1.5 text-xs text-white/70">
                <i className="ri-check-line text-white/80 w-4 h-4 flex items-center justify-center"></i>
                Guide aggiornate
              </span>
              <span className="flex items-center gap-1.5 text-xs text-white/70">
                <i className="ri-check-line text-white/80 w-4 h-4 flex items-center justify-center"></i>
                Analisi indipendente
              </span>
              <span className="flex items-center gap-1.5 text-xs text-white/70">
                <i className="ri-check-line text-white/80 w-4 h-4 flex items-center justify-center"></i>
                Confronti dettagliati
              </span>
              <span className="flex items-center gap-1.5 text-xs text-white/70">
                <i className="ri-check-line text-white/80 w-4 h-4 flex items-center justify-center"></i>
                Informazioni sulla sicurezza
              </span>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="w-full max-w-md aspect-square rounded-2xl overflow-hidden bg-white/10 backdrop-blur-sm">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20modern%20laptop%20with%20clean%20spreadsheet%20interface%20on%20warm%20oak%20wooden%20desk%2C%20surrounded%20by%20a%20ceramic%20coffee%20cup%20and%20a%20small%20succulent%20plant%2C%20soft%20natural%20window%20light%20creating%20gentle%20shadows%2C%20minimalist%20European%20home%20office%20aesthetic%2C%20warm%20neutral%20tones%20with%20subtle%20sage%20green%20accents%2C%20editorial%20interior%20photography%2C%20no%20text%20no%20logos%20no%20watermarks&width=800&height=800&seq=hero-side-v2&orientation=squarish&nocache=true"
                alt="Itaobuy Spreadsheet workspace"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}